import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  orderHeader:any;
  currency:any;
  convenienceCharge
  constructor(public navParams:NavParams) { 
    console.log('nav param',this.navParams.data)
  }

  ngOnInit() {
    this.orderHeader = this.navParams.data.orderHeader;
    this.currency = localStorage.getItem('currency');
    this.convenienceCharge = JSON.parse(localStorage.getItem("HomeProperty")).convenienceName;
  }

}
